export default function ArrowBackIos(props)
{
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="currentcolor">
    <polygon points="17.77,3.77 16,2 6,12 16,22 17.77,20.23 9.54,12"/>
  </svg>;
}
